import LaunchScreen from "../pages/LaunchScreen";
import Dashboard from "../pages/Dashboard";
import AddExpense from "../pages/AddExpense";
import ExpenseList from "../pages/ExpenseList";
import ProjectDetail from "../pages/ProjectDetail";
import Chat from "../pages/Chat";
import Projects from "../pages/Projects";
import Team from "../pages/Team";
import Invoice from "../pages/Invoice";
import CreateInvoice from "../pages/CreateInvoice";
import InvoiceDetail from "../pages/InvoiceDetail";
import EditInvoice from "../pages/EditInvoice";
import SuperUsersList from "../pages/SuperUsersList";
import SuperNotifications from "../pages/SuperNotifications";
import SuperDashboard from "../pages/SuperDashboard";
import UserDashboard from "../pages/UserDashboard";
import UserProjectDetail from "../pages/UserProjectDetail";
import UserChat from "../pages/UserChat";
import ProjectInvoiceDetail from "../pages/ProjectInvoiceDetail";
import EditProjectInvoice from "../pages/EditProjectInvoice";
import SetUserPassword from "../pages/setUserPassword";
import Settings from "../pages/Settings";
import LinkedInCallback from "../components/LinkedInCallback";

export const routesConfig = [
  {
    path: "/",
    element: <LaunchScreen />,
    protected: false,
  },
  {
    path: "/setPassword",
    element: <SetUserPassword />,
    protected: false,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
    protected: true,
  },
  {
    path: "/addExpense",
    element: <AddExpense />,
    protected: true,
  },
  {
    path: "/expenseList",
    element: <ExpenseList />,
    protected: true,
  },
  {
    path: "/projects",
    element: <Projects />,
    protected: true,
  },
  {
    path: "/chats",
    element: <Chat />,
    protected: true,
  },
  {
    path: "/team",
    element: <Team />,
    protected: true,
  },
  {
    path: "/invoices",
    element: <Invoice />,
    protected: true,
  },
  {
    path: "/invoice",
    element: <InvoiceDetail />,
    protected: true,
  },
  {
    path: "/editInvoice",
    element: <EditInvoice />,
    protected: true,
  },
  {
    path: "/projectInvoice",
    element: <ProjectInvoiceDetail />,
    protected: true,
  },
  {
    path: "/editProjectInvoice",
    element: <EditProjectInvoice />,
    protected: true,
  },
  {
    path: "/createInvoice",
    element: <CreateInvoice />,
    protected: true,
  },
  {
    path: "/project",
    element: <ProjectDetail />,
    protected: true,
  },
  {
    path: "/setting",
    element: <Settings />,
    protected: true,
  },
  { path: "/linkedin", element: <LinkedInCallback />, protected: false },
  {
    path: "/admin/dashboard",
    element: <SuperDashboard />,
    protected: true,
  },
  {
    path: "/admin/userList",
    element: <SuperUsersList />,
    protected: true,
  },
  {
    path: "/admin/notification",
    element: <SuperNotifications />,
    protected: true,
  },
  {
    path: "/user/dashboard",
    element: <UserDashboard />,
    protected: true,
  },
  {
    path: "/user/addExpense",
    element: <AddExpense />,
    protected: true,
  },
  {
    path: "/user/expenseList",
    element: <ExpenseList />,
    protected: true,
  },
  {
    path: "/user/chat",
    element: <UserChat />,
    protected: true,
  },
  {
    path: "/user/project",
    element: <UserProjectDetail />,
    protected: true,
  },
];
